import { spacing } from '@rbilabs/universal-components/themes';
import { StyleSheet, View } from 'react-native';

import { centeredRowContainerStyles } from 'components/layout/centered-row-container';
import { LoyaltySkeletonHeader } from 'pages/loyalty/loyalty-skeleton/loyalty-skeleton-header';
import { WEB_SMALL_MAX_WIDTH } from 'utils/constants';

import { LoyaltySkeleOfferCard } from './loyalty-skeleton-offer-card';

export const LoyaltyOffersSkeletonLoader = () => {
  return (
    <View style={styles.container}>
      <LoyaltySkeletonHeader />
      {Array.from({ length: 7 }).map((_, i) => (
        <LoyaltySkeleOfferCard key={i} />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    ...centeredRowContainerStyles.content,
    maxWidth: WEB_SMALL_MAX_WIDTH,
    paddingHorizontal: spacing.$4,
  },
});
